'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const React = require('react');

const HeadingLevelContext = React.createContext({
  level: 1
});
const useHeadingLevel = () => React.useContext(HeadingLevelContext);
const HeadingLevelProvider = ({ level = 1, children }) => {
  return jsxRuntime.jsx(HeadingLevelContext.Provider, { value: {
    level
  }, children });
};

exports.HeadingLevelProvider = HeadingLevelProvider;
exports.useHeadingLevel = useHeadingLevel;
//# sourceMappingURL=HeadingLevelContext.cjs.js.map
